import { z } from 'zod';
/**
 * Five categories rendered on the global market ticker.
 * Matches launch spec §7.2 table.
 */
export const tickerCategorySchema = z.enum([
    'equities', 'crypto', 'fx', 'commodities', 'bonds',
]);
/**
 * Source identifier — one-to-one with `market_data_source_config.source_id`
 * rows seeded by migration 20260420000000. 'fred' is a shared identifier for
 * both commodities (WTI, Nat Gas) and bonds (10Y UST, JP 10Y); the separate
 * 'fred_ticker' row in source_config tracks ticker-specific FRED usage vs.
 * the panel-rate and financing-terms consumers.
 */
export const tickerSourceSchema = z.enum([
    'twelve_data', 'coingecko', 'frankfurter', 'fred', 'metals_api',
]);
/**
 * One row in the scrolling ticker. `change_abs` + `change_pct` are nullable
 * for the Metals-API case — the free tier's 50/month budget doesn't allow
 * a second call for yesterday's price, so we ship today's price without a
 * delta rather than burning the quota.
 */
export const tickerItemSchema = z.object({
    category: tickerCategorySchema,
    symbol: z.string().min(1),
    price: z.number(),
    change_abs: z.number().nullable(),
    change_pct: z.number().nullable(),
    as_of: z.string(),
    source: tickerSourceSchema,
    unit: z.string().optional(),
});
/**
 * Payload returned by `GET /api/market-data/ticker`.
 * Mirrored loosely in the web hook as a type-only import — apps/web must not
 * runtime-depend on the shared-types ESM dist (ts-jest/vitest ESM quirk),
 * so web uses `import type { TickerPayload }`.
 */
export const tickerPayloadSchema = z.object({
    items: z.array(tickerItemSchema),
    fetched_at: z.string(),
    categories_available: z.array(tickerCategorySchema),
    warnings: z.array(z.string()),
});
